import React, { ReactChild, useState, useEffect, useContext } from 'react';
import { IComponentActInfo } from '../../component.d';
import { IGalleryStatus } from '../../global.d';
import { IMedium } from '../../store/VideoStore';
import './ActInfo.scss';

import { ThemeContext } from '../../store/ThemeProvider';
import intl from 'react-intl-universal';
import { getPendantColor } from '../../utils/color';
import chroma from 'chroma-js';
import ReactSVG from 'react-svg';
import BottomModal from '../ButtonGroup/BottomModal';
import { getNameByType } from '../ButtonGroup/AllForButtonGroup';
import ActInfo from '../ButtonGroup/ActInfo';
import { getGalleryStatus } from '../../utils/util';
import moment from 'moment';
import classNames from 'classnames';
import { getCompatibleCls, multiLine } from '../../utils/dom';

export default (props: IComponentActInfo) => {
  const {
    edittype,
    content,
    show_status,
    show_view,
    title,
    show_info,
    api
  } = props;
  const { componentColor, mainColor, h1Color, h2Color } = useContext(
    ThemeContext
  );
  const [total, setTotal] = useState(0);
  const [realStatus, setRealStatus] = useState(IGalleryStatus.wait);

  useEffect(() => {
    if(!window.pageDetail.video_data) {
      const { rootStore } = props;
      rootStore!.galleryStore
        .getLinkLatest(window.pageDetail.link_id)
        .then((dt: any) => {
          if (dt && dt.data && dt.data.items) {
            setTotal(Math.max(dt.data.items.length, dt.data.total));
          }
        });
    }
  }, []);

  const chooseWhichTotal = ()=>{
    if(window.pageDetail.video_data) {
      let video = props.rootStore.videoStore!.getVideo(Number(window.pageDetail.video_data));
      if(video) {
        return Math.max(0, Number(video.uv));
      }
    }

    return total;
  };

  const [modalTitle, setModalTitle] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalChild, setModalChild] = useState('' as ReactChild);
  const showActInfoDialog = () => {
    if (typeof show_info != 'undefined' && show_info === false) {
      return;
    }
    setModalTitle(getNameByType('act-info'));
    setShowModal(true);
    let childContent = '' as ReactChild;
    childContent =
      edittype == 'template' ? (
        <ActInfo edittype={edittype} content={content} />
      ) : (
        content
      );

    setModalChild(childContent);
  };

  const getRealStatus = () => {
    // 首先确定，当前是不是视频页
    if (Number(window.pageDetail.video_data)) {
      const { rootStore } = props;
      rootStore
        .videoStore!.checkVideoExist(Number(window.pageDetail.video_data))
        .then((res: IMedium) => {
          if (res) {
            if (res.type == 'live' && res.source_detail) {
              setRealStatus(res.source_detail.status);
            } else {
              setRealStatus(res.status as IGalleryStatus);
            }
          }
        });
    }
    // 再确定，当前是不是
    else if (window.dataDetail) {
      let temp = window.dataDetail.status;
      let { start_time, end_time } = window.dataDetail;
      if (typeof start_time != 'undefined' && typeof end_time != 'undefined') {
        if (moment().isBefore(start_time)) {
          temp = IGalleryStatus.wait;
        } else if (moment().isAfter(end_time)) {
          temp = IGalleryStatus.end;
        } else if (moment().isBetween(start_time, end_time)) {
          temp = IGalleryStatus.start;
        }
      }
      setRealStatus(temp);
    } else {
      let temp = window.gallery.status;
      let { start_time, end_time } = window.gallery;
      if (typeof start_time != 'undefined' && typeof end_time != 'undefined') {
        if (moment().isBefore(start_time)) {
          temp = IGalleryStatus.wait;
        } else if (moment().isAfter(end_time)) {
          temp = IGalleryStatus.end;
        } else if (moment().isBetween(start_time, end_time)) {
          temp = IGalleryStatus.start;
        }
      }
      setRealStatus(temp);
    }
  };

  useEffect(() => {
    getRealStatus();
  }, []);

  const [status, statusColor] = getGalleryStatus(realStatus);

  const getView = () => {
    const { rootStore } = props;
    if(window.pageDetail.video_data) {
      let video = props.rootStore.videoStore!.getVideo(Number(window.pageDetail.video_data));
      if(video) {
        return Math.max(0, Number(video.view));
      }

      return 0;
    }else {
      if(!window.pageDetail.data) {
        rootStore.pagedataStore!.getGallerys([window.gallery.id]);
      }
      let pagedataCount = rootStore.pagedataStore!.getViewDetail(false, true);
      return pagedataCount && pagedataCount.imageviews
        ? pagedataCount.imageviews
        : 0;
    }
  };
  const cls = getCompatibleCls('component-actinfo', api);

  return (
    <div className={cls}>
      <div className="main-title" onClick={showActInfoDialog}>
        <div className="title" style={{ color: h1Color }}>
          {multiLine(title || window.pageDetail.title)}
        </div>
        {typeof show_info != 'undefined' && show_info === false ? null : (
          <div
            className="arrow"
            style={{
              color: chroma(h1Color)
                .alpha(0.4)
                .css()
            }}
          >
            {intl.get('More')}
            <ReactSVG
              src={require('../../svg/actinfo-arrow.svg')}
              className={'i'}
              style={{
                fill: chroma(h1Color)
                  .alpha(0.4)
                  .css(),
                marginLeft: 8
              }}
            />
          </div>
        )}
      </div>
      <div className="status-info">
        {show_status ? (
          <div className="status">
            <ReactSVG
              src={require('../../svg/actinfo-status.svg')}
              className={'i'}
              style={{ fill: mainColor }}
            />
            <span style={{ color: mainColor }}>{status}</span>
          </div>
        ) : null}
        {show_view ? (
          <div className="usercount">
            <span
              style={{
                color: chroma(h1Color)
                  .alpha(0.4)
                  .css()
              }}
            >
              {intl.get('PeopleCount')}
            </span>
            <span
              style={{
                color: chroma(h1Color)
                  .alpha(0.4)
                  .css(),
                marginRight: 15
              }}
            >
              {chooseWhichTotal()}
            </span>
            <span
              style={{
                color: chroma(h1Color)
                  .alpha(0.4)
                  .css()
              }}
            >
              {intl.get('View')}
            </span>
            <span
              style={{
                color: chroma(h1Color)
                  .alpha(0.4)
                  .css()
              }}
            >
              {getView()}
            </span>
          </div>
        ) : null}
      </div>

      <BottomModal
        title={modalTitle}
        show={showModal}
        onHide={() => setShowModal(false)}
        child={modalChild}
      />
    </div>
  );
};
